import { DrinkScheduleBuilder } from "./drink.schedule.builder";
import { DayOfWeekSchedule } from "src/app/core/product/enums";
import { DrinkPrices } from "../prices/drink.prices.model";
import { DrinkException } from "../exceptions/drink.exceptions.model";

export class DrinkSchedule {
  public readonly isDailyPrice: boolean;
  public readonly price: number;
  public readonly activeWeekdays: DayOfWeekSchedule;
  public readonly weekdayPrices: DrinkPrices;
  public readonly exceptions: DrinkException[];

  constructor(builder: DrinkScheduleBuilder) {
    this.isDailyPrice = builder.isDailyPrice;
    this.price = builder.price;
    this.activeWeekdays = builder.activeWeekdays;
    this.weekdayPrices = builder.weekdayPrices.build();
    this.exceptions = builder.exceptions;
  }

  public get isActiveMonday(): boolean {
    return this.activeWeekdays.monday;
  }
  public get isActiveTuesday(): boolean {
    return this.activeWeekdays.tuesday;
  }
  public get isActiveWednesday(): boolean {
    return this.activeWeekdays.wednesday;
  }
  public get isActiveThursday(): boolean {
    return this.activeWeekdays.thursday;
  }
  public get isActiveFriday(): boolean {
    return this.activeWeekdays.friday;
  }
  public get isActiveSaturday(): boolean {
    return this.activeWeekdays.saturday;
  }
  public get isActiveSunday(): boolean {
    return this.activeWeekdays.sunday;
  }
  public get priceOnMonday(): number {
    return this.weekdayPrices.monday;
  }

  public get priceOnTuesday(): number {
    return this.weekdayPrices.tuesday;
  }

  public get priceOnWednesday(): number {
    return this.weekdayPrices.wednesday;
  }
  public get priceOnThursday(): number {
    return this.weekdayPrices.thursday;
  }
  public get priceOnFriday(): number {
    return this.weekdayPrices.friday;
  }
  public get priceOnSaturday(): number {
    return this.weekdayPrices.saturday;
  }
  public get priceOnSunday(): number {
    return this.weekdayPrices.sunday;
  }
}
